import type { TransformedLocationData as LocationTransformedLocationData } from '../LocationTracking/types';

export type { Coordinate, TransformedLocationData } from '../LocationTracking/types';

export enum TrackingCardState {
  InTransit = 'inTransit',
  AtTxCenter = 'atTxCenter',
  Unavailable = 'unavailable',
  Default = 'default',
  NonTmdxLogistics = 'nonTmdxLogistics',
}

export type ArrivalLabel = 'Organ ETA' | 'Organ STA';

export type TrackingBannerConfig = {
  message: string;
  showArrivalTime: boolean;
  progress: number;
  progressVariant: 'static' | 'completed';
};

export type TrackingStateConfig = {
  title: string;
  banner: TrackingBannerConfig | null;
};

export type TrackingActivePosition = NonNullable<LocationTransformedLocationData['activePosition']>;

export type LocationTrackingDisplayData = {
  donorOrTime: string | null;
  donorOrTz: string | null;
  etaDate: string | null;
  etaTime: string | null;
  etaTz: string | null;
  arrivalLabel: ArrivalLabel;
  organOnOCSTimestamp: string | null;
  caseName: string;
  donorHospitalCode: string;
  txCenterCode: string;
  txCenterOrTime: string | null;
  txCenterOrTz: string | null;
  etaTimestamp: string | null;
};
